import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';

$(() => {
    detailsAccommodation.init();
});

const detailsAccommodation = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && +this.$booking.attr('data-dynamicpackage') === 0)) {
            return;
        }

        if($('[data-isFixDepartures]').attr('data-isFixDepartures')) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;
        this.allowedServices = $('[data-allowedservices]').attr('data-allowedservices');
        this.allowedServices = this.allowedServices ? JSON.parse(this.allowedServices) : [];
        this.params.isTravelgate = $('[data-isTravelgate]').attr('data-istravelgate');

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }
        
        if(this.form) {
            functions.setFormData(this.form, this.params);
        }

        const formData = functions.getFormData(this.$form);
        this.params.serviceCode = formData.serviceCode ? formData.serviceCode : null;

        this.getCalculation();
        
        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        // check availability on form change (not only on btn click)
        $('[name="dates"], [name=guests], [name=serviceCode]').on('change', () => {
            const data = functions.getFormData(this.$form);
            if ( data.dates || data.guests ) {
                this.$form.trigger('submit');
            }
        });

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $(window).on('hashchange', e => {
            this.getParams();
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.getCalculation(this.params);
        });

        if(this.$cart.length) {
            const $btnBooking = $('.btn-booking');

            $btnBooking.on('click', e => {
                e.preventDefault();
                let cartData = [];

                detailsAccommodation.cart.cartItems.forEach(item => {
                    item = JSON.parse(item);
                    cartData.push({
                        'unitId': item.unitId,
                        'dateFrom': item.dateFrom,
                        'dateTo': item.dateTo,
                        'aDateFrom': item.aDateFrom,
                        'aDateTo': item.aDateTo,
                        'guests': item.guests,
                        'flightUnitId': item.flightUnitId,
                        'time': item.time,
                        'serviceCode': item.serviceCode,
                        'serviceId': item.serviceId,
                        'pricelistId': detailsAccommodation.params.pricelistId,
                        'dynamicPackage': 0,
                    });
                });

                if(detailsAccommodation.cart.cartItems.length) {
                    location = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=0';
                } else {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }
        else {
            $(document).on('click', '.unit .btn-book-one-unit', e => {

                e.preventDefault();
                const $btnBooking = $(e.currentTarget);

                if (! detailsAccommodation.params.dateFrom || ! detailsAccommodation.params.dateTo || ! detailsAccommodation.params.guests) {
                    window.setAlertBooking($btnBooking);
                    return;
                }

                let cartData = {
                    'unitId': $btnBooking.attr('data-unitid'),
                    'dateFrom': detailsAccommodation.params.dateFrom,
                    'dateTo': detailsAccommodation.params.dateTo,
                    'guests': detailsAccommodation.params.guests,
                    'pricelistId': $btnBooking.attr('data-pricelistid'),
                    'serviceCode': $btnBooking.attr('data-servicecode') ? encodeURIComponent($btnBooking.attr('data-servicecode')) : null,
                    'serviceId': $btnBooking.attr('data-serviceid')
                };

                let extras = $btnBooking.attr('data-extra');
                if (extras) {
                    extras = JSON.parse(extras);

                    Object.keys(extras).forEach(function(key) {
                        let val = extras[key];
                        if (key === 'optionRefId' || key === 'remoteUnitId') {
                            val = encodeURIComponent(val);
                        } else if (key === 'cancellationPolicy') {
                            return;
                        }
                        cartData[key] = val;
                    });
                }

                location = $(e.currentTarget).attr('data-href') + '?dynamicPackage=0&cart_data=' + JSON.stringify([cartData]);
            });

        }

        $(document).on('change', '.block-totals-per-service [type="radio"]', e => {

            const $unit = $(e.currentTarget).closest('.unit');
            const $addToCart = $unit.find('.add-to-cart');
            const $btnBooking = $unit.find('.btn-book-one-unit');
            const $radioService = $unit.find('[type="radio"]:checked');
            const $totalPerService = $radioService.closest('.total-per-service');

            let total = $totalPerService.find('[data-totalperservice]').attr('data-totalperservice');
            let totalOld = $totalPerService.find('[data-oldtotalperservice]').attr('data-oldtotalperservice');
            let currency = $totalPerService.find('[data-currency]').attr('data-currency');
            let bookingStatus = $totalPerService.find('[data-bookingstatus]').attr('data-bookingstatus');
            let pricelistid = $totalPerService.find('[data-pricelistid]').attr('data-pricelistid');
            let serviceId = $radioService.attr('data-serviceval');
            let serviceKey = $radioService.attr('data-servicekey');
            let extras = $radioService.attr('data-extra');

            if ($addToCart.length) {
                $addToCart.attr('data-' + serviceKey, serviceId);
                $addToCart.attr('data-unitcarttotal', total);
                $addToCart.attr('data-unitcarttotalold', totalOld);
                $addToCart.attr('data-currencysymbol', currency);
                $addToCart.attr('data-pricelistid', pricelistid);

                $addToCart.attr('data-datefrom', detailsAccommodation.params.dateFrom);
                $addToCart.attr('data-dateto', detailsAccommodation.params.dateTo);
                $addToCart.attr('data-guests', detailsAccommodation.params.guests);

            } else {
                $btnBooking.attr('data-' + serviceKey, serviceId);
                $btnBooking.attr('data-pricelistid', pricelistid);
                $btnBooking.attr('data-extra', extras);

                if (extras) {
                    extras = JSON.parse(extras);
                    const unitId = $unit.attr('data-unitid');
                    let $cp = '<div>Za odabrani termin nije moguć povraćaj novca u slučaju otkazivanja.</div>';

                    if (this.params.isTravelgate && extras.cancellationPolicy && extras.cancellationPolicy.length) {

                        $cp = '<div>';
                        $cp += 'Možete besplatno otkazati rezervaciju do <strong>' + functions.decreaseDate(extras.cancellationPolicy[0].deadline, 1) + '</strong><br>';

                        extras.cancellationPolicy.forEach((item, key) => {
                            if (item.penaltyType === 'IMPORT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + functions.formatMoney(item.value, 2, ',', '') +' '+ item.currency + '</strong>.<br>';
                            }
                            else if (item.penaltyType === 'PERCENT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + item.value + '%</strong>.<br>';
                            }
                            else if (item.penaltyType === 'NIGHTS') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naplaćuje se naknada u iznosu  <strong> ' + item.value + 'noćenja</strong>.<br>';
                            }
                        });
                        $cp += '</div>';
                    }

                    const board = $(e.currentTarget).closest('.form-check').find('.form-check-label').text() ? $(e.currentTarget).closest('.form-check').find('.form-check-label').text() : $unit.find(".service-label").text();
                    const $unitModal =  $("#unitModal-" + unitId);

                    $unitModal.find("#cancellationPolicy-" + unitId).html($cp);
                    $unitModal.find('.modal-service-name').html(board);
                }

                $btnBooking.text(bookingStatus === 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));
            }
        });
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;

        cParams.calcPerService = 1;
        const calculation = details.getCalculation(cParams);

        if (this.params.isTravelgate) {
            $(".units-no-result-msg").addClass('d-none');
            $(".unit:not(.unit-default)").addClass('d-none');
        }

        if(calculation) {

            if (this.params.isTravelgate) {
                $(".unit-default").addClass('d-none');
                $('.units-spinner').removeClass('d-none');
            } else {
                details.unitsSpinner();
            }

            //$('.rate-container').addClass('d-none');

            calculation
                .done(response => {
                    this.calculationDone(response, cParams);

                    if (this.params.isTravelgate) {
                        $('.units-spinner').addClass('d-none');
                    }

                }).fail(error => {
                console.log(error);
            });

            return;
        } else {
            $('.total-label').addClass('d-none'); 
            $('.price-from-label').removeClass('d-none');
            $('.price').attr('data-totalperservice', null);
            $('.price').attr('data-currency', null);
            $('.price').attr('data-bookingstatus', null);
            $('.price').attr('data-pricelistid', null);
            $('.add-to-cart').attr('data-dateFrom', null);

            $('.price').text($('.price').attr('data-price'));
            $('.price-old').text($('.price-old').attr('data-priceOld'));
        }

        $('.rate-container').removeClass('d-none');
        $('.block-totals-per-service').addClass('d-none');
        $('.unit-error-message').addClass('d-none');
    },
    preparePriceAndBooking(unitId, $unit, unitData, params) {

        const $totalPerServiceBlock = $unit.find('.totals-per-service');
        const totalPerServiceHtml = $totalPerServiceBlock.html();

        let discountTitle;
        $totalPerServiceBlock.html('');

        const unitServices = Object.keys(unitData.services);
        const unitServiceCount = unitServices.length;

        Object.keys(unitData.services).forEach(( serviceId) => {

            const dataPerService = unitData.services[serviceId];

            const unitCalc = dataPerService.calc;
            const currencySymbol = unitCalc.currencySymbol;
            const bookingStatus = dataPerService.booking.status;
            const unitCalcItems = unitCalc.items;
            const total = unitCalc.total.toFixed(2);
            const pricelistid = unitCalc.items[0].pricelistId;

            const $totalPerServiceHtml = $(totalPerServiceHtml);

            let priceOld = details.getCalcTotalOld(unitCalcItems);
            priceOld = +priceOld.toFixed(2);

            let serviceText = '';
            if (dataPerService.customServiceName) {
                serviceText = dataPerService.customServiceName;
            } else {
                detailsAccommodation.allowedServices.forEach((allowedService) => {
                    if (dataPerService.serviceId && +allowedService.id === +dataPerService.serviceId ||
                        dataPerService.serviceCode && allowedService.key === dataPerService.serviceCode){
                        serviceText = allowedService.text;
                    }
                });

                if ( ! serviceText)
                {
                    if (dataPerService.serviceName) {
                        serviceText = dataPerService.serviceName;
                    }
                }
            }

            let totalRounded = functions.formatMoney(total, 0, '', '');
            $totalPerServiceHtml.attr('style', 'order:' + totalRounded);
            $totalPerServiceHtml.addClass('order-' + totalRounded);
            $totalPerServiceHtml.attr('data-order' , totalRounded);

            const $radio = $totalPerServiceHtml.find('[type="radio"]');

            const radioVal = serviceId;
            $radio.val(radioVal);
            $radio.attr('name', 'service-' + unitId);
            $radio.attr('id', 'service-' + unitId + '-' + radioVal);
            $radio.attr('data-servicekey', dataPerService.serviceCode ? 'serviceCode' : 'serviceId');
            $radio.attr('data-serviceval', dataPerService.serviceId || dataPerService.serviceCode);

            let extra = {};
            if (dataPerService.optionRefId) {
                extra.optionRefId = dataPerService.optionRefId;
            }

            if (unitData.unitName) {
                extra.unitName = unitData.unitName;
            }

            if (unitData.remoteUnitId) {
                extra.remoteUnitId = unitData.remoteUnitId;
            }

            if (dataPerService.cancellationPolicy) {
                extra.cancellationPolicy = dataPerService.cancellationPolicy;
            }

            $radio.attr('data-extra', JSON.stringify(extra));

            const $label = unitServiceCount > 1 ? $totalPerServiceHtml.find('label') : $unit.find('.service-label');

            if (dataPerService.tag) {
                serviceText += '<span class="ms-2 badge text-bg-primary-lt">'+(dataPerService.tag === 'nonref' ? 'non refundable' : 'refundable')+'</span>';
            }

            $label.html(serviceText);
            $label.attr('for', 'service-' + unitId + '-' + radioVal);

            const $oldTotal = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-oldtotalperservice]') : $unit.find('.price-old');
            $oldTotal.text(priceOld > total ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
            $oldTotal.attr('data-oldtotalperservice', priceOld > total ? priceOld : '');

            const $total = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-totalperservice]') : $unit.find('.price');
            $total.text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
            $total.attr('data-totalperservice', total);
            $total.attr('data-currency', currencySymbol);
            $total.attr('data-bookingStatus', bookingStatus);
            $total.attr('data-pricelistid', pricelistid);

            $totalPerServiceBlock.append($totalPerServiceHtml[0].outerHTML);
        });

        let minp = null;
        $totalPerServiceBlock.find("[data-order]").each((index, elem) => {
            let p = +$(elem).attr('data-order');
            if (minp === null || p < minp) {
                minp = p;
            }
        });

        $totalPerServiceBlock.find(".order-" + minp).find('[type="radio"]').click();
        $totalPerServiceBlock.find(".order-" + minp).addClass('border-0');
    },
    calculationDone(response, params) {

        $('.unit[data-dynamicunitid]').remove();

        if(response.status) {
            const data = response.data || [];

            if (this.params.isTravelgate) {
                $(".units-no-result-msg").addClass('d-none');
            }

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                let $unit = $('.unit[data-unitid=' + unitId + ']');
                let $unitModal = $("#unitModal-" + unitId);
                if ( ! $unit.length )
                {
                    if (unitId.indexOf('_') === -1) return;

                    const _unitId = unitId.replace(/_\d+$/, "");
                    const $_unitId = $($('.unit[data-unitid=' + _unitId + ']').prop('outerHTML'));

                    $_unitId.attr('data-dynamicunitid', unitId);
                    $(".units").append($_unitId);

                    $unit = $('.unit[data-dynamicunitid=' + unitId + ']');
                    $unitModal = $("#unitModal-" + _unitId);
                }

                let isBookable = false;

                const unitServiceCount = unitData.services ? Object.values(unitData.services).length : 0;
                $('.rate-container').length && $('.rate-container').toggleClass('d-none', unitServiceCount > 1);

                if(unitData.services && details.isBookablePerService(unitData.services)) {
                    isBookable = true;
                    const total = details.getMinPricePerService(unitData.services);
                    detailsAccommodation.preparePriceAndBooking(unitId, $unit, unitData, params);
                    $unit.prop('style', 'order: ' + parseInt(total));
                } else {
                    $unit.prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-message').text(error);

                if (isBookable) {
                    $unit.find('.price-from-label').addClass('d-none');
                    $unit.find('.total-label').removeClass('d-none'); 
                } else {
                    $unit.find('.total-label').addClass('d-none'); 
                    $unit.find('.price-from-label').removeClass('d-none');
                }

                $unit.find('.block-totals-per-service').toggleClass('d-none', ! isBookable || unitServiceCount < 2);
                $unit.find('.fast-and-secure-label').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                if (this.params.isTravelgate) {
                    $unit.toggleClass('d-none', ! isBookable);
                    $unit.find('[data-unitName]').text(unitData.unitName);
                    $unitModal.find('.modal-unit-name').html(unitData.unitName);
                    let totalGuests = +params.guests.split(',')[0] + +params.guests.split(',')[1];
                    $unit.find('.unit-no-guests').text(totalGuests);
                }

            });

            if (this.params.isTravelgate && ! $(".units .unit").not('.d-none').length) {
                $(".units-no-result-msg").removeClass('d-none');
            }

            $('.unit-default').addClass('d-none');
        }
    },
    calculationDoneOld(response, params) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);

                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);
                    priceOld && $unit.find('.price-old').html(totalOld);
                    discountTitle && $unit.find('.badge-discount').html(discountTitle);

                    $unit.prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);

                    $addToCart.attr('data-datefrom', detailsAccommodation.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsAccommodation.params.dateTo);
                    $addToCart.attr('data-guests', detailsAccommodation.params.guests);
                } else {
                    $unit.prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-message').text(error);

                $unit.find('.price-from-label').addClass('d-none');
                $unit.find('.total-label').removeClass('d-none');   
                
                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);

                if (unitData.optionRefId) {
                    let $btn = $unit.find('.btn-book-one-unit');
                    $btn.attr('data-serviceCode', unitData.serviceCode);
                    $btn.attr('data-optionRefId', unitData.optionRefId);
                    $btn.attr('data-unitName', unitData.unitName);
                    $btn.attr('data-remoteUnitId', unitData.remoteUnitId);
                }
            });

            if(this.$cart.length) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 0,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=0';

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {

                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget);

                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsAccommodation.params.dateFrom,
                            'dateTo': detailsAccommodation.params.dateTo,
                            'guests': detailsAccommodation.params.guests,
                            'serviceCode': encodeURIComponent($target.attr('data-servicecode') || detailsAccommodation.params.serviceCode),
                            'optionRefId': encodeURIComponent($target.attr('data-optionrefid')),
                            'unitname': $target.attr('data-unitname'),
                            'remoteUnitId': encodeURIComponent($target.attr('data-remoteunitid'))
                            //'dynamicPackage': 0,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true'; // &dynamicPackage=0
                });
            }
        }
    }
};